import { useRef } from 'react'

export const useFilesInput = (onUpload: (files: FileList | null) => void) => {
  const ref = useRef<HTMLInputElement>(null)

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target

    onUpload(files)
  }

  const handleOnclick = () => {
    if (!ref.current) {
      return
    }
    ref.current.click()
    ref.current.value = ''
  }

  return {
    ref,
    handleUpload,
    handleOnclick,
  }
}
